import { RootState } from 'duck/store'
import { isEmpty } from 'lodash'
import ThumbsUpIcon from 'mdi-react/ThumbsUpIcon'
import React from 'react'
import { connect } from 'react-redux'
import { Organization } from 'scenes/Dashboard/data/organizations/types'

import { createStyles, List, ListItem, ListItemIcon, ListItemText, Theme, Typography } from '@mui/material'
import { withStyles, WithStyles } from '@mui/styles'

class OrganizationReferral extends React.PureComponent<OrganizationReferralProps> {
  render() {
    const { referrers, classes } = this.props
    if (!referrers) {
      return null
    }
    return (
      <div className={classes.section}>
        <Typography variant="h6" paragraph>
          Organization Referrers
        </Typography>
        <List>
          {referrers.map((referral) => (
            <ListItem key={referral.value}>
              <ListItemIcon>
                <ThumbsUpIcon />
              </ListItemIcon>
              <ListItemText primary={referral.value} />
            </ListItem>
          ))}
        </List>
      </div>
    )
  }
}

type OrganizationReferralProps = WithStyles<typeof styles> & {
  organization: Organization
  referrers?: Organization['referrers']
}

function mapStateToProps(state: RootState, { organization }: ContainerProps): StateProps {
  if (!organization || isEmpty(organization.referrers)) {
    return {}
  }

  return {
    referrers: organization.referrers,
  }
}

type StateProps = Pick<OrganizationReferralProps, 'referrers'>
type ContainerProps = Pick<OrganizationReferralProps, 'organization'>

const styles = ({ spacing }: Theme) =>
  createStyles({
    section: {
      marginTop: spacing(4),
    },
  })

export default connect(mapStateToProps)(withStyles(styles)(OrganizationReferral))
